import useApi, { ApiOptions } from '../base/useApi';
import JobDTO from '@src/adapters/dto/job/JobDTO';

interface Params {
  productionId: string;
  pageSize: number;
  currentPage: number;
}

interface Result {
  jobs: JobDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/job/find',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindJobsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindJobsLazy;
